"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.PageSEO = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactSeo = require("@alterpage/react-seo");

var _pageContext = require("./page-context");

var _excluded = ["htmlAttributes", "children"];

var PageSEO = function PageSEO(_ref) {
  var htmlAttributes = _ref.htmlAttributes,
      children = _ref.children,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);

  var _usePageContext = (0, _pageContext.usePageContext)(),
      locale = _usePageContext.locale,
      meta = _usePageContext.meta,
      relatedPaths = _usePageContext.relatedPaths,
      pathname = _usePageContext.pathname,
      baseUrl = _usePageContext.baseUrl;

  var attributes = (0, _extends2.default)({}, htmlAttributes, {
    lang: locale
  });
  return /*#__PURE__*/_react.default.createElement(_reactSeo.SEO, (0, _extends2.default)({
    meta: meta,
    relatedPaths: relatedPaths,
    htmlAttributes: attributes,
    baseUrl: baseUrl
  }, rest), baseUrl && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: "" + baseUrl + pathname
  }), children);
};

exports.PageSEO = PageSEO;